import { paths } from "../../config/paths";
import { LandingPage } from "../../features/landing-page/LandingPage";

export const BeautyProfilerHome = () => {
  return (
    <LandingPage
      backgroundPath="/beauty-profiler/landing-page.mp4"
      subtitle="Unveal Your Iconic"
      title="allure"
      description="Beauty Profiler"
      path={paths.beautyProfiler.profiler.path}
    />
  );
};
